import React, {useEffect, useState, useRef} from 'react'
import {useIntl} from 'react-intl'
// import arrowUpGreen from '../../../../_metronic/assets/images/svg/data-room/arrow-up-green.svg'
// import arrowDownRed from '../../../../_metronic/assets/images/svg/data-room/arrow-down-red.svg'
import '../styles/Dashboard.scss'
import {getActiveRound} from '../../investor-crm/core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
// import { useShortScale } from '../../../hooks/useShortScale'
import {DateTime} from 'luxon'
import {getDashboardActivity, getDashboardStatistics, getReactivateSubscriptionDetails} from '../core/_requests'
// import { roleValues } from '../../../core/_constants'
import TagManager from 'react-gtm-module'
import {GTMEvent, loginSuccessMeta} from '../../../hooks/gtmHelpers'
import Skeleton from 'react-loading-skeleton'
import {DemoInfoCard} from '../../widgets/components/UI/DemoInfoCard'
import brandingConfig from '../../../../config/brandingConfig'
import {Card} from 'react-bootstrap'
// import DataActivity from '../../recordskeeper-ai/components/Overview/DataActivity'
import FileUsage from '../../recordskeeper-ai/components/Overview/FileUsage'
import AvailableStorage from '../../recordskeeper-ai/components/Overview/AvailableStorage'
// import ReferEarn from '../../../../media/images/refer-earn.png'
import RetentionPeriod from '../../recordskeeper-ai/components/AnalyticsAndReports/RetentionPeriod'
import QuickAction from '../../recordskeeper-ai/components/AnalyticsAndReports/QuickAction'
// import CaptableManagementListSkeleton from '../../captable-management/components/CaptableManagementListSkeleton'
import {getShareholderOverview} from '../../captable-management/core/_requests'
// import CaptableManagementList from '../../captable-management/components/CaptableManagementList'
// import CaptableManagementMapSkeleton from '../../captable-management/components/CaptableManagementMapSkeleton'
// import CaptableManagementMap from '../../captable-management/components/CaptableManagementMap'
import {getShareholdersDashboardCounts} from '../../stakeholders/stakeholders-and-investors/core/_requests'
import RecordsKeeperAIGenerator from '../../recordskeeper-ai/components/RecordsKeeperAIGenerator'
import {removeNullFields} from '../../../core/_util'
import {OverviewDataActivity} from '../../recordskeeper-ai/components/Overview/OverviewDataActivity'
import {DataActivityTypes} from '../../recordskeeper-ai/core/_models'
import {getOverviewDataActivityApi, getOverviewDataApi} from '../../recordskeeper-ai/core/_requests'
import { getDashboardCountsApi } from '../../digital-signing/core/_requests'
// import { PaymentDue } from '../components/PaymentDue'
// import { getAnalyticStat } from '../../recordskeeper-ai/core/_requests'

export const DashboardMainRK = () => {
  const mounted = useRef(false)
  const {formatMessage} = useIntl()
  const [activeRound, setActiveRound] = useState<any>()
  const {currentUser, companyId, role, selected, currencyBill, currentState, isShowDemoDashboard} =
    useAuth()
  // const { convertValueToShortScale } = useShortScale()
  const [overviewDataActivityData, setOverviewDataActivityData] = useState<DataActivityTypes>({
    uploadedFileSizes: [],
    downloadedFileSizes: [],
  })

  const [analyticStatData, setAnalyticStatData] = useState<any>({}) //eslint-disable-line
  // const [analyticStatLoading, setAnalyticStatLoading] = useState(false)
  const [selectedDataActivity, setSelectedDataActivity] = useState('thisWeek')

  const [files, setFiles] = useState() //eslint-disable-line
  const [user, setUser] = useState() //eslint-disable-line
  const [dataActivityLoading, setDataActivityLoading] = useState(false) //eslint-disable-line
  const [loading, setLoading] = useState(false) //eslint-disable-line
  const currentMonth = DateTime.now().toFormat('yyyyMM') //eslint-disable-line
  const previousMonth = DateTime.now().minus({months: 1}).toFormat('yyyyMM')
  const [actualMonth, setActualMonth] = useState<string>(previousMonth) //eslint-disable-line
  const [compareMonth, setCompareMonth] = useState<string>(previousMonth) //eslint-disable-line
  const [statisticsData, setStatisticsData] = useState<any>([])
  const [statisticLoading, setStatisticLoading] = useState(false)
  const [dashboardActivityData, setDashboardActivityData] = useState<any>([])
  const [dataLoadingError, setDataLoadingError] = useState(false)
  const [errorMessages, setErrorMessages] = useState<string[]>([])
  const [dashboardLoading, setDashboardLoading] = useState(false) //eslint-disable-line
  const [overviewData, setOverviewData] = useState<any>()
  const [investors, setInvestors] = useState<any[]>() //eslint-disable-line
  const [countryCounts, setCountryCounts] = useState({//eslint-disable-line
    countriesCount: {
      indianCountryCount: 0,
      otherCountriesCount: [
        {
          countryId: 0,
          countryName: '',
        },
      ],
      totalOtherCountriesCount: 0,
      totalCountriesCount: 0,
    },
  }) // eslint-disable-next-line

  const getOverview = async () => {
    setDashboardLoading(true)
    try {
      if (companyId) {
        const {
          data: {success, data, errors},
        }: any = await getShareholderOverview(companyId)
        if (success) {
          setOverviewData(data)
          const transformedInvestors = data.topShareInvestors?.map((shareholder: any) => ({
            name: shareholder.legalName || `${shareholder.firstName} ${shareholder.lastName}`,
            value: shareholder.percentage,
          }))
          setInvestors(transformedInvestors)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDashboardLoading(false)
    }
  }
  // const analyticStat = async () => {
  //   if (!companyId) return
  //   try {
  //     setAnalyticStatLoading(true)
  //     const {
  //       data: { success, data, errors },
  //     } = await getAnalyticStat(companyId, files, user)
  //     if (success) {
  //       setAnalyticStatData(data)
  //     } else {
  //       console.error(errors)
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   } finally {
  //     setAnalyticStatLoading(false)
  //   }
  // }
  const getActiveRoundFromApi = async () => {
    try {
      // if (companyId && role && role !== roleValues.BILLING) {
      if (companyId) {
        const {
          data: {success, data: apiActiveRound, errors},
        } = await getActiveRound(companyId)
        if (success) {
          setActiveRound(apiActiveRound)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
            setErrorMessages((prev) => [...prev, formatMessage({id: error})])
          })

          setDataLoadingError(true)
        }
      }
    } catch (error) {
      console.log(error)
      setDataLoadingError(true)
      setErrorMessages((prev) => [...prev, 'Failed to fetch active round'])
    } finally {
      //   setLoading(false)
    }
  }
  const fetchOverviewData = async () => {
    if (!companyId) return
    setLoading(true)
    try {
      const {
        data: {success, data},
      } = await getOverviewDataApi(companyId)
      if (success) {
        setOverviewData(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }
  const fetchDataActivity = async () => {
    if (!companyId) return
    setDataActivityLoading(true)
    try {
      const {
        data: {success, data},
      } = await getOverviewDataActivityApi(companyId, selectedDataActivity)
      if (success) {
        setOverviewDataActivityData(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setDataActivityLoading(false)
    }
  }
  const getAllStatistics = async () => {
    setStatisticLoading(true)
    try {
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getDashboardStatistics(companyId, actualMonth, compareMonth)
        if (success) {
          setStatisticLoading(false)
          setStatisticsData(data)
        } else {
          setStatisticLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
            setErrorMessages((prev) => [...prev, formatMessage({id: error})])
          })

          setDataLoadingError(true)
        }
      }
    } catch (err) {
      setStatisticLoading(false)
      console.log(err)
      setDataLoadingError(true)
      setErrorMessages((prev) => [...prev, 'Failed to fetch dashboard statistics'])
    }
  }

  const getAllDashboardActivity = async () => {
    try {
      // if (companyId && role && role !== roleValues.BILLING) {
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getDashboardActivity(companyId)
        if (success) {
          setDashboardActivityData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
            setErrorMessages((prev) => [...prev, formatMessage({id: error})])
          })

          setDataLoadingError(true)
        }
      }
    } catch (err) {
      console.log(err)
      setDataLoadingError(true)
      setErrorMessages((prev) => [...prev, 'Failed to fetch dashboard activities'])
    }
  }

  useEffect(() => {
    if (mounted.current) {
      const isDataLoaded = statisticsData.newInvestors !== undefined
      const isDashboardActivityDataLoaded = dashboardActivityData.todayActivities !== undefined

      if (!statisticLoading && isDataLoaded && isDashboardActivityDataLoaded) {
        setTimeout(() => {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DashboardViewSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                ...loginSuccessMeta(currentUser, `${selected}-${currencyBill}-${currentState}`),
              }),
            },
          })
        }, 400)
      }
    } else {
      // Mark as mounted for subsequent renders
      mounted.current = true
    }
  }, [selected]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (mounted.current && dataLoadingError) {
      console.error('Dashboard loading failed:', errorMessages.join(', '))

      setTimeout(() => {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.DashboardViewFailed,
            action: 'normal',
            metadata: removeNullFields({
              ...loginSuccessMeta(currentUser, `${selected}-${currencyBill}-${currentState}`),
              error: errorMessages.join(', '),
            }),
          },
        })
      }, 500)
    }
  }, [dataLoadingError, errorMessages, selected]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getActiveRoundFromApi()
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getAllStatistics()
  }, [companyId, actualMonth, compareMonth]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getAllDashboardActivity()
  }, [companyId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const investorImg: string[] = []
  activeRound?.allInvestors.forEach((investor: any) => {
    if (investor.file !== null) {
      investorImg.push(investor?.file?.name)
    }
  })

  // const chartData = {
  //   netProfit: [44, 55, 57, 56, 61, 58, 63, 60, 66],
  //   revenue: [76, 85, 101, 98, 87, 105, 91, 114, 94],
  //   freeCashFlow: [35, 41, 36, 26, 45, 48, 52, 53, 41],
  // }

  useEffect(() => {
    getOverview()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getCountryCounts = async () => {
    try {
      const {
        data: {data},
      } = await getShareholdersDashboardCounts(companyId!)
      if (data) {
        setCountryCounts(data)
      }
    } catch (error) {
      console.log(error)
    } finally {
    }
  }
  useEffect(() => {
    getCountryCounts()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchDataActivity()
  }, [selectedDataActivity]) // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchOverviewData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps


  const [dashboardCounts, setDashboardCounts] = useState<{
    shareholdersCount: {
      shareholdersIndividuals: {
        shareholdersIndividualsTotalCount: number
        shareholdersIndividualsCountByDay: any[]
      }
      shareholdersInstitutions: {
        shareholdersInstitutionsTotalCount: number
        shareholdersInstitutionsCountByDay: any[]
      }
      totalShareholdersCount: number
    }
    countriesCount: {
      indianCountryCount: number
      otherCountriesCount: {
        countryId: number
        countryName: string
      }[]
      totalOtherCountriesCount: number
      totalCountriesCount: number
    }
    stakeholderCategoryCount: {
      individuals: number
      institutions: number
      employees: number
    }
    topFiveShareholders:
    | {
      shareholderDetails: {
        shareholderId: number
        shareholderName: string
        entityType: string
        profileImage: string | null
      }
      totalShares: number
    }[]
    | []
  }>({
    shareholdersCount: {
      shareholdersIndividuals: {
        shareholdersIndividualsTotalCount: 0,
        shareholdersIndividualsCountByDay: [],
      },
      shareholdersInstitutions: {
        shareholdersInstitutionsTotalCount: 0,
        shareholdersInstitutionsCountByDay: [],
      },

      totalShareholdersCount: 0,
    },

    countriesCount: {
      indianCountryCount: 0,
      otherCountriesCount: [
        {
          countryId: 0,
          countryName: '',
        },
      ],
      totalOtherCountriesCount: 0,
      totalCountriesCount: 0,
    },
    stakeholderCategoryCount: {
      individuals: 0,
      institutions: 0,
      employees: 0,
    },
    topFiveShareholders: [],
  })

  const getDashboardCounts = async () => {
      setDashboardLoading(true)
      try {
        const {
          data: { data },
        } = await getShareholdersDashboardCounts(companyId!)
        if (data) {
          setDashboardCounts(data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setDashboardLoading(false)
      }
    }
    useEffect(() => {
      getDashboardCounts()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
  


    const [dashboardSignCounts, setSignDashboardCounts] = useState({
        actionRequired: 0
      })
    
      const getSignDashboardCounts = async () => {
        setDashboardLoading(true)
        try {
          const {
            data: { data },
          } = await getDashboardCountsApi(companyId!)
          if (data) {
            setSignDashboardCounts(data)
          }
        } catch (error) {
          console.log(error)
        } finally {
          setDashboardLoading(false)
        }
      }
    
      useEffect(() => {
        getSignDashboardCounts()
      }, []) // eslint-disable-line react-hooks/exhaustive-deps

      const [reactiveSubscriptionDetails, setReactiveSubscriptionDetails] = useState<any>()
      const getReactivateSubscription = async () => {
          try {
            if (companyId) {
              const {
                data: { success, data },
              } = await getReactivateSubscriptionDetails(companyId)
              if (success) {
                setReactiveSubscriptionDetails(data)
              }
            }
          } catch (err) {
            console.log(err)
          } finally {
          }
        }
      
        useEffect(() => {
          if (companyId) {
            getReactivateSubscription()
          }
        }, [companyId])// eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <div className='px-md-5 px-3 data-rooms-overview-wrapper pb-9 dashboard-main mx-md-1 mx-0'>
        <div>
          <h5 className='mb-8'>{formatMessage({id: 'My Dashboard'})}</h5>
        </div>

        {isShowDemoDashboard && (
          <DemoInfoCard
            title={formatMessage({
              id: `Welcome to Your ${brandingConfig.brandName}’s Demo Dashboard`,
            })}
            className='mb-0'
            desc={formatMessage({
              id: 'The demo dashboard showcases a comprehensive overview of your record management activities through intuitive visualizations and key metrics. It automatically populates with your actual data and analytics once you start actively using the platform.',
            })}
            slug={brandingConfig.helpLinks.mainDashboardOverview}
          />
        )}

        <RecordsKeeperAIGenerator />
        <div className='data-rooms-stats-grid gap-4'>
          {statisticLoading ? (
            Array(4)
              .fill(null)
              .map((_, index) => (
                <div className='bg-white rounded-2 p-6' key={index}>
                  <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      className='mb-4'
                    />
                  <Skeleton
                      height={44}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
              </div>
              ))
          ) : (
            <>
              <div className='bg-white rounded-2 p-6'>
                <p className='mb-0 text-muted mb-4'>{formatMessage({id: 'Total Records'})}</p>
                <h1 className='mb-0 text-dark font-size-32 lh-base'>{reactiveSubscriptionDetails?.fileUploadCount || 0}</h1>
              </div>

              <div className='bg-white rounded-2 p-6'>
                <p className='mb-0 text-muted mb-4'>{formatMessage({id: 'Total Team Members'})}</p>
                <h1 className='mb-0 text-dark font-size-32 lh-base'>{reactiveSubscriptionDetails?.totalTeamMembers || 0}</h1>
              </div>

              <div className='bg-white rounded-2 p-6'>
                <p className='mb-0 text-muted mb-4'>{formatMessage({id: 'Stakeholder Counts'})}</p>
                <h1 className='mb-0 text-dark font-size-32 lh-base'>{dashboardCounts?.shareholdersCount?.totalShareholdersCount || 0}</h1>
              </div>

              <div className='bg-white rounded-2 p-6'>
                <p className='mb-0 text-muted mb-4'>{formatMessage({id: 'Pending Signing'})}</p>
                <h1 className='mb-0 text-dark font-size-32 lh-base'>{dashboardSignCounts?.actionRequired || 0}</h1>
              </div>
            </>
          )}
        </div>

        <div className='d-md-flex gap-4 my-4'>
          <div className='d-flex flex-md-row flex-column gap-4 w-100'>
            <Card className='data-activity-card bg-white'>
              <OverviewDataActivity
                dataActivity={overviewDataActivityData}
                isLoading={dataActivityLoading}
                selectedDataActivity={selectedDataActivity}
                setSelectedDataActivity={setSelectedDataActivity}
              />
            </Card>
            <Card className='file-usage-card bg-white'>
              <FileUsage overviewData={overviewData} loading={loading} />
            </Card>
            {/* <div className=' d-flex flex-column gap-4 justify-content-start w-100' style={{ width: '15%' }}> */}
            <Card className='justify-content-center bg-white storage-available-card'>
              <AvailableStorage />
            </Card>
          </div>
        </div>

        {/* <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
          <div className='d-flex flex-md-row flex-column w-100 gap-4 justify-content-between'>
            {dashboardLoading ? (
              <>
                <CaptableManagementListSkeleton />
                <CaptableManagementListSkeleton />
              </>
            ) : (
              investors && (
                <>
                  <CaptableManagementList
                    title='Top #5 Investors'
                    data={overviewData.top5Investors}
                  />
                  <CaptableManagementList
                    title='Top #5 Promoters'
                    data={overviewData.top5Promoters}
                  />
                </>
              )
            )}
          </div>
          <div className='d-flex w-100'>
            {dashboardLoading ? (
              <CaptableManagementMapSkeleton />
            ) : (
              <CaptableManagementMap title='Stakeholder By Country' countryCounts={countryCounts} />
            )}
          </div>
        </div> */}

        {/* <div className='row'>
          <div className='mb-6 col-md-6 col-12'>
            <RetentionPeriod />
          </div>
          <div className='mb-6 col-md-6 col-12'>
            <QuickAction />
          </div>
        </div> */}
        <div className='d-flex flex-md-row flex-column gap-4 justify-content-between'>
          <div className='w-100'>
            <RetentionPeriod
              retentionData={analyticStatData.recordWithMaxRetention as any[]}
              isLoading={loading}
            />
          </div>
          <div className='w-100'>
            <QuickAction />
          </div>
        </div>
      </div>
    </>
  )
}
